import React from 'react';
import { X } from 'lucide-react';

interface MissingParametersErrorProps {
  missingParams: string[];
}

export function MissingParametersError({ missingParams }: MissingParametersErrorProps) {
  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center p-6 text-center">
      <div className="bg-red-50 border-2 border-red-200 rounded-lg p-8 max-w-lg shadow-lg">
        <div className="w-16 h-16 bg-red-100 text-red-500 rounded-full flex items-center justify-center mx-auto mb-4">
          <X size={32} />
        </div>
        <h2 className="text-xl font-bold text-red-700 mb-4">Missing Required Parameters</h2>
        <p className="text-gray-700 mb-4">
          The following parameters must be provided for the widget to function properly:
        </p>
        <ul className="mb-4 bg-white p-4 border border-red-100 rounded-md text-left">
          {missingParams.map(param => (
            <li key={param} className="mb-2">
              <code className="bg-gray-100 px-2 py-1 rounded text-red-600 font-mono">{param}</code>
              <span className="ml-2 text-sm text-gray-600">
                {param === 'user_id' 
                  ? 'Required to track design credits and save designs' 
                  : param === 'user_image_url' 
                    ? 'Required to use as the original image for renovation'
                    : param === 'client_key'
                      ? 'Required to activate the widget and authenticate API requests'
                      : ''}
              </span>
            </li>
          ))}
        </ul>
        <p className="text-sm text-gray-600">
          Please update the URL parameters and try again.
        </p>
      </div>
    </div>
  );
}